import React from 'react';
import styled from 'styled-components';

const EventRow = styled.div`
  display: flex;
  font-size: 11px;
  line-height: 20px;
  font-family: 'ArialMonospacedMT', monospace;
`;

export default EventRow;
